export const GET_AUTH = 'Auth/';
export const GET_USER = 'User/';
export const GET_PERMISSION ='UserType/'
export const GET_WAREHOUSE = 'Warehouse/';
export const GET_STATES = 'States/';
export const GET_STATE = 'State/';
export const GET_CITY = 'City/';
export const GET_CITIES = 'cities';
export const GET_COUNTRY = 'Country/';
export const GET_CURRENCY = 'Currency/';
export const GET_BUSINESS_SETTTING = 'BusinessSetting/';
export const GET_BRANCH = 'Branch/';
export const GET_CHANGE_PASSWORD = GET_AUTH + 'changePassword';
export const GET_FORGOT_PASSWORD = GET_AUTH + 'forgotPassword';
export const GET_VERIFY_OTP = GET_AUTH + 'verifyOtp';
export const SET_NEW_PASSWORD = GET_AUTH + 'setNewPassword';
export const GET_MODULE = 'Module/';
export const GET_VEHICLE_TRANSMISSION = "VehicleTransmission/";
export const GET_VEHICLE_TYPE = "VehicleType/";
export const GET_VEHICLE_MANUFACTURER = "VehicleManufacture/";
export const GET_VEHICLE_DETAILS ='VehicleDetail'
export const GET_CURRENCY_CONVERSION ="CurrencyConversion/";
export const GET_VEHICLE_MODEL = "VehicleModel/";
export const RESET_PASSWORD = "Auth/resetPassword/";
export const GET_VEHICLE = "Vehicle/";
export const GET_UINTOFMEASUREMENT = "UnitofMeasurement/";
export const GET_CATEGORY = "Category/";
export const GET_UINTOFMEASUREMENT_CONVERSION = "UOMConversion/";
export const GET_SUPPLIER = "Supplier/";
export const GET_PRODUCT = "Product/";
export const GET_SUPPLIER_PRODUCT = "SupplierProductMapping/importsupplierproductmapping/";
export const GET_GRN ='GRN/';
export const GET_SUPPLIER_PRODUCT_LIST = "SupplierProductMapping/"
export const IMPORT_PRODUCT = "Product/import/"
export const PAYMENTTERMS = 'PaymentTerms';
export const PURCHASEORDER = 'PurchaseOrder/';
export const GET_PAYMENT_TERMS ='PaymentTerms/';
export const GET_BACKORDERPO ='PurchaseOrder/backOrderPo/'
export const GET_BACKORDER ='PurchaseOrder/backOrder';
export const IMPORT_CURRENCY_CONVERSION = "CurrencyConversion/import/";
export const IMPORT_SUPPLIER = "Supplier/import/";
export const GET_BRAND ="Brand/";
export const GET_PURCHASERETURN ="purchaseReturn/";
export const GET_CUSTOMERTYPE ="CustomerType/";
export const GET_ASSEMBLY ="Assembly/";
export const GET_SUPPLIER_ASSEMBLY ="AssemblySupplierMapping/import/";
export const GET_SUPPLIER_ASSEMBLY_LIST = "AssemblySupplierMapping/";
export const GET_GRN_MANUAL= "GRN/manual/";
export const GET_INVOICENUMBER= "GRN/grn";
export const GET_DISCOUNT= "CustomerTypeDiscount/";
export const GET_CATEGORY_DISCOUNT= "CustomerTypeDiscount/addCategoryDiscount";
export const GET_ENGINE= "Engine/";
export const GET_ENGINE_SEARCH= "Engine/search";
export const VEHICLE_PRODUCT_MAPPING= "VehicleProductMapping/vehicleproductmapping";
export const GET_VEHICLE_PRODUCT_MAPPING= "VehicleProductMapping";
export const GET_CUSTOMER_TYPE_PRODUCT_MARGIN= "CustomerTypeProductMargin";
export const GET_ASSEMBLED_PRODUCT ="AssembledProduct/";
export const GET_INVENTORY = "Inventory/";
export const GET_QTYINHAND_PRODUCT ='Requisition/getQtyByCategory';
export const GET_REQUISITION ='Requisition/';
export const GET_USER_PROFILE ='User/userProfile/';
export const GET_REQUISITION_WAREHOUSE ='Requisition/warehouseStore';
export const GET_REQUISITION_PROCESS ="Requisition/process/";
export const GET_CUSTOMER = 'Customer/';
export const GET_PRODUCT_SEARCH = 'product/search';
export const GET_CUSTOMER_TRANSACTION = 'CustomerTransaction/';
export const GET_CUSTOMER_PAYMENT_SERACH ='Customer/paymentSearch/';
export const GET_CUSTOMER_PAYMENT ='Customer/payment/';
export const GET_REQUEST_APPROVAL='CustomerTransaction/customerRequest/'
export const GET_REQUEST_APPROVAL_ID='CustomerTransaction/customerRequestById';
export const GET_CREDIT_INVOICE ='CustomerTransaction/pendingInvoice/';
export const GET_TRANSACTION_QUOTATION='CustomerTransaction/quotation/';
export const GET_CREDIT_TRANSACTION = 'CustomerTransaction/submit/creditPayment';
export const GET_UPDATE_TOKEN = 'auth/updateToken';
export const GET_CATEGORY_PRODUCTCODE='Product/productsByCategoryId';
export const GET_CATEGORY_ASSEMBLYCODE='Assembly/assemblyByCategoryId';
export const GET_INVOICE_SETTLEMENT = 'CustomerTransaction/invoiceStatement';
export const GET_CUSTOMER_TRANSACTION_ALL = 'CustomerTransaction/getAll';
export const GET_PO_RETURN_REPORT ='Reports/GetPurchaseReturnReport/';
export const GET_PO_REPORT='Reports/GetPurchaseOrderReports/';
export const GET_ASSEMBLY_GRN ='Assembly/grn';
export const GET_PRODUCT_GRN = 'Product/grn';
export const GET_CUSTOMER_REPORT ='Reports/GetCustomerReport/';
export const GET_STOCK_REPORT ='Reports/GetStockcountReport/';
export const GET_SALESMAN_REPORT ='Reports/GetSalesmanReport/';
export const GET_SALES_REPORT ='Reports/GetSalesReport/';
export const GET_SALES_RETURN_REPORT ='Reports/GetSalesReturnReport/';
export const GET_SUPPLIER_PRODUCT_REPORT ='Reports/GetSupplierProductReport/';
export const GET_INVENTORY_REPORT ='Reports/GetInventoryReport/';
export const GET_REQUISITION_REPORT ='Reports/GetRequisitionReport/';
export const GET_REQUISITION_SENDER_REPORT ='Reports/GetRequisitionSenderReport/';
export const GET_VALIDATE_PASSWORD ='CustomerTransaction/validatepassword/';
export const GET_INVOICE_SETTING='InvoiceSetting/';
export const GET_NOTIFICATION = "Notification";
export const GET_TERMINAL= "Terminal";
export const GET_QUOTATION_TRANSACTION = "CustomerTransaction/quotationRecord";
export const GET_SALES_RETURN = "SalesReturn/";
export const GET_TRANSACTION_ALLSTORETRANSACTION ='CustomerTransaction/alltransactions';
export const GET_STORE_TERMINAL='Branch/getAllTerminalsWithUserStatus/';
export const GET_ASSEMBLY_MAPPING ='AssemblyMapping/';
export const GET_DASHBOARD ='DashBoard/';
export const GET_FINGERPRINT ='Fingerprint/';
